<template>
  <div id="aniversario">

    <header>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="logo">
              <!-- <a href="/"><img :src="logo" /></a> -->
            </div>
          </div>

          <div class="col-md-6">
            <div class="form">
              <h1>Você organiza a sua festa e seus presentes podem ajudar quem mais precisa em forma de doações.</h1>
              <span>Ao criar um evento com nossa ferramenta, seus convidados podem doar para a Organização Social que mais toca o seu coração e que foi escolhida por você.</span>

              <form>
                <div class="input">
                  <label>Informe seu e-mail</label>
                  <input type="text" name="email" v-model="email" placeholder="email@email.com.br" />
                  <button @click.stop.prevent="createInvite()">CRIAR MEU CONVITE</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div id="main">
      <div class="container">
        <div class="row">
          <div class="intro col-md-6 offset-md-3">
            <div class="base">
              <div class="content">
                <h2>Convites do Bem, uma forma diferente de celebrar e ajudar aqueles que mais precisam.</h2>
                <b>Já pensou em organizar uma festa ou um evento solidário? 
                  Com a ferramenta Convites do Bem é muito fácil e você pode escolher entre as diversas Organizações Sociais cadastradas em nossa plataforma.</b>
                  <br>
                  <span>Crie hoje mesmo um evento e envie para seus convidados os Convites do Bem!</span>
              </div>
            </div>
          </div>
        </div>

        <div class="steps row">
          <div class="step col-md-3">
            <div class="number">
              <span><font-awesome-icon :icon="['fas', 'calendar-alt']" size="lg" /></span>
            </div>
            <h3>Crie um Convite</h3>
            <p>Preencha os dados principais do seu evento: nome do evento, data, horário e local.</p>
          </div>

          <div class="step col-md-3">
            <div class="number">
              <span><font-awesome-icon :icon="['fas', 'home']" size="lg" /></span>
            </div>
            <h3>Escolha um Projeto Social</h3>
            <p>Escolha um projeto social que toca o seu coração e que você queira ajudar.</p>
          </div>

          <div class="step col-md-3">
            <div class="number">
              <span><font-awesome-icon :icon="['fas', 'share-square']" size="lg" /></span>
            </div>
            <h3>Envie via Whatsapp</h3>
            <p>Envie para os convidados do seu evento os Convites do Bem.</p>
          </div>

          <div class="step col-md-3">
            <div class="number">
              <span><font-awesome-icon :icon="['fas', 'gift']" size="lg" /></span>
            </div>
            <h3>Comemore a transformação</h3>
            <p>Ao receber os convites seus convidados poderão fazer doações dos valores equivalentes dos presentes que você iria receber e você acompanha as doações.</p>
          </div>
        </div>

        <div class="row d-none d-sm-block">
          <div class="form col-md-12">
            <div class="content">
              <h3>Crie agora mesmo um Convite do Bem e ajude aqueles que mais precisam!</h3>
              <span>É simples, rápido e fácil!</span>
              <form>
                <div class="input">
                  <label>Informe seu e-mail</label>
                  <input type="text" name="email" v-model="email" placeholder="email@email.com.br" />
                  <button @click.stop.prevent="createInvite()">CRIAR MEU CONVITE</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- <div class="about row">
          <div class="col-md-6">
            <h2>Conheça um pouco sobre a Click2Giv</h2>
            <p>Conectamos Organizações Sociais, Varejo e Pessoas através de ferramentas de Marketing Relacionado à Causa
              e geramos valor por meio da ampliação do conceito de doação. Queremos que o ato de doar seja incorporado 
              ao dia a dia das pessoas e naquilo que elas já fazem.</p>
            <p> Ferramentas de comunicação, relacionamento e divulgação,
              integrada à redes sociais em um único ambiente. Fácil de usar e simples como deve ser. Acreditamos no poder da 
              comunicação para ampliar o conceito de doação, engajamento e fraternidade.</p>
          </div>

          <div class="col-md-6">
            <div class="video">

            </div>

            <div class="description">
              <span><b>Conheça a história da Click2Giv:</b> Doação é quando fazemos o bem para o próximo sem esperar nada em troca.</span>
            </div>
          </div>
        </div> -->

      </div>
    </div>

    <footer>
      <div class="container">
        <div class="row">
          <div class="col-md-4 description">
            <h2>Conheça alguns Projetos Sociais cadastrados em nossa plataforma!</h2>
            <p>Escolha um projeto que toca seu coração e transforme vidas Faça do seu evento um momento de transformação social.</p>
          </div>
        </div>

        <div class="row" v-if="projects">
          <div class="col-md-12">
            <carousel :perPage="perPage" :navigationEnabled="navigationEnabled" :paginationEnabled="paginationEnabled" :autoplay="autoPlay">

              <slide v-for="(p, k) in projects" :key="k" @click="openProject(p.slug)">
                <div class="image">
                  <img :src="p.Info.image" />
                </div>
                <span v-if="p.Categories[0] && p.Categories[0].name">{{p.Categories[0].name}}</span>
                <h3>{{p.Info.title}}</h3>
                <p>{{p.Info.shortDescription}}</p>
              </slide>

            </carousel>
          </div>
        </div>
      </div>

      <div class="base">
        <!-- <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="company">
                <p><b>Click2Giv Serviços Online Ltda.</b> - CNPJ 12.636.988/0001-12</p>
              </div>
              <div class="contact">
                <p><b>suporte@click2giv.com - (11) 98741-1000</b></p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </footer>

  </div>
</template>

<script>

import logo from '../../assets/images/logo_black.png';
import Functions from '../../utils/functions';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faChevronCircleUp, faCalendarAlt} from '@fortawesome/fontawesome-free-solid'
import Loading from '../includes/Loading'
import { API } from '../../services/api'
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'Home',
  components: {
    FontAwesomeIcon,
    Carousel,
    Slide,
    Loading
  },
  data () {
    return {
      loading: false,
      projects: null,
      categories: null,
      logo: logo,
      isAuth: false,
      email: null,
      projects: null,
      resultProjects: null,
      user: null,
      perPage: 4,
      navigationEnabled: true,
      paginationEnabled: true,
      autoPlay: false
    }
  },
  created(){
    this.loadProjects();
  },
  mounted (){
    if(window.innerWidth < 415){
      this.perPage = 1
      this.navigationEnabled = false
      this.paginationEnabled = false
      this.autoPlay = true
    }
  },
  methods: {
    createInvite(){
      if(this.email && this.email != ''){
        localStorage.setItem('inviteEmail', this.email);
        this.$router.push('/aniversariodobem/create');
      }else{
        alert("Você deve digitar um e-mail antes de continuar!");
      }
      return false;
    },
    loadProjects(){
      this.$http.get(API.Projects.projects).then((result) => {
        this.projects = result.body;
        var featuredProjects = this.projects.filter((e) => {
          return (e.isFeatured) && e.Categories[0].name;
        });
        featuredProjects = Functions.arrayShuffle(featuredProjects)
        featuredProjects.splice(8, featuredProjects.length - 8);
        this.projects = featuredProjects
      });
    },
    openProject(slug){
      this.$router.push({path: '/project/' + slug});
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#aniversario{
  padding-bottom: 80px;
}

h1{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 44px;
  line-height: 45px;
  letter-spacing: -0.04em;
  color: #333;
}

h2{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 35px;
  line-height: 40px;
  letter-spacing: -0.01em;
  color: #333;
}

h3{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 25px;
  line-height: 25px;
  letter-spacing: -0.01em;
  color: #333;
}

header{
  width: 100%;
  display: block;
  height: 979px;
  background: url('../../assets/images/bkg-top-aniversario.jpg') top center;

  .logo{
    margin-top: 50px;
  }

  .form{
    margin-top: 200px;
    span{
      font-family: Rubik;
      color: #333;
      margin-top: 10px;
      width: 80%;
      display: block;
    }

    form{

      .input{
        margin-top: 30px;
        width: 80%;
        height: 70px;
        background-color: #fff;
        border-radius: 10px;
        position: relative;
        
        label{
          color: #00AE39;
          font-size: 14px;
          position: absolute;
          top: 5px;
          left: 10px;
          font-family: Rubik;
        }

        input{
          position: absolute;
          width: 60%;
          top: 25px;
          padding-bottom: 5px;
          padding-top: 5px;
          font-size: 16px;
          left: 10px;
          border: none;
          margin: none;
          color: #333;
          font-family: Rubik;
          &:focus{
            outline: none;
          }
        }

        button{
          position: absolute;
          right: -20px;
          height: 70px;
          color: #fff;
          background-color: #FB101F;
          border: none;
          border-radius: 0px 10px 10px 0px;
          cursor: pointer;
          font-family: Rubik;
        }
      }
    }
  }
}

#main{
  width: 100%;
  display: block;
  min-height: 1330px;
  padding-bottom: 100px;
  position: relative;

  .intro{

    .base{
      width: 100%;
      height: 30px;
      position: relative;
    }

    .content{
      // max-width: 470px;
      text-align: center;
      position: absolute;
      top: -150px;

      span{
        font-family: Rubik;
        color: #333;
      }
    }
  }

  .steps{
    margin-top: 100px;

    .step{
      text-align: center;
      .number{
        width: 200px;
        height: 200px;
        background-color: #F2F7F5;
        margin: 0 auto;
        border-radius: 100px;
        position: relative;

        span{
          width: 90%;
          height: 90%;
          display: block;
          border: 2px dashed #00AE39;
          border-radius: 100px;
          position: absolute;
          left: 10px;
          top: 10px;
          font-size: 90px;
          padding: 10px;
          text-align: center;
        }

        svg{
          font-size: 1em;
        }
      }

      h3{
        margin-top: 20px;
        width: 100%;
        height: 50px;
      }
    }
  }

  .form{
    margin-top: 40px;
    background-color: #F2F7F5;
    padding: 50px;
    text-align: center;
    border-radius: 20px;
    border: 1px dashed #00AE39;
    box-sizing: border-box;

    .content{
      max-width: 400px;
      margin: 0 auto;

      span{
        font-family: Rubik;
        margin-top: 10px;
        display: block;
      }
    }

    form{
      .input{
        margin-top: 30px;
        width: 100%;
        height: 70px;
        background-color: #fff;
        border-radius: 10px;
        position: relative;
        
        label{
          color: #00AE39;
          font-size: 14px;
          position: absolute;
          top: 5px;
          left: 10px;
          font-family: Rubik;
        }

        input{
          position: absolute;
          width: 60%;
          top: 25px;
          padding-bottom: 5px;
          padding-top: 5px;
          font-size: 16px;
          left: 10px;
          border: none;
          margin: none;
          color: #333;
          font-family: Rubik;
          &:focus{
            outline: none;
          }
        }

        button{
          position: absolute;
          right: -20px;
          height: 70px;
          color: #fff;
          background-color: #FB101F;
          border: none;
          border-radius: 0px 10px 10px 0px;
          cursor: pointer;
          font-family: Rubik;
        }
      }
    }
  }

  .about{
    margin-top: 60px;

    p{
      margin-top: 20px;
      font-family: Rubik;
      color: #333;
    }
  }
}

footer{
  width: 100%;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  height: 690px;
  background-color: #F2F7F5;
  border-top: 1px dashed #00AE39;

  .description{
    margin-top: 50px;
  }

  .VueCarousel-slide{
    height: 400px;
    padding-right: 20px;

    .image{
      width: 100%;
      height: 130px;
      border-radius: 10px;
      overflow: hidden;

      img{
        width: 100%;
      }
    }

    h3{
      font-size: 20px;
    }

    span{
      color: #00AE39;
      font-size: 14px;
      font-family: Rubik;
      margin-top: 10px;
      display: block;
    }

    p{
      font-family: Rubik;
      font-size: 14px;
      display: block;
      margin-top: 10px;
    }
  }

  .base{
    width: 100%;
    height: 50px;
    background-color: #fff;
    border-top: 1px dashed #00AE39;
    position: absolute;
    bottom: 0;

    .company{
      float: left;
      margin-top: 15px;

      p{
        font-family: Rubik;
      }

      b{
        font-weight: bold;
      }
    }

    .contact{
      float: right;
      margin-top: 15px;

      p{
        font-family: Rubik;
      }
    }
  }
}

@media screen and (max-width: 414px) {

  header{
    height: 700px;
    background-position: right bottom;

    .logo{
      text-align: center;
    }

    .form{
      margin-top: 40px;
      text-align: center;

      h1{
        font-size: 26px;
      }

      span{
        width: 100%;
      }
      form{
        .input{
          width: 100%;

          button{
            right: 0px;
            font-size: 14px;
          }
        }
      }
    }
  }

  #main{
    margin-top: 50px;
    padding-bottom: 380px;

    .intro{
      .content{
        text-align: center;
      }
    }

    .form{
      .input{
          width: 100%;

        button{
          right: 0px;
          font-size: 14px;
        }
      }
    }
  }

  footer{
    height: 740px;
    .VueCarousel-slide{
      padding: 20px;
    }

    .description{
      text-align: center;
    }

    .base{
      height: auto;

      .company, .contact{
        float: none;
        text-align: center;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/aniversariodobem/AniversarioHome.vue